module.exports = __webpack_public_path__ + "static/media/banner_960.77e9b919.jpg";